/**
 * Product Inquiry Form - Post-submit modal reopen
 *
 * After form submission, Shopify redirects to the product URL with
 * #product-inquiry-form hash. This script detects the hash and
 * programmatically opens the modal to show success/error messages.
 *
 * Uses the window 'load' event to guarantee that all deferred scripts
 * (including the theme's MicroModal.init()) have fully executed.
 */
(function () {
  "use strict";

  if (window.location.hash !== "#product-inquiry-form") return;

  // Clean up hash immediately to prevent reopen on refresh
  if (window.history && window.history.replaceState) {
    window.history.replaceState(
      null,
      "",
      window.location.pathname + window.location.search,
    );
  }

  // 'load' fires after all deferred scripts, stylesheets, and images are ready
  window.addEventListener("load", function () {
    var modal = document.querySelector('[id^="inquiry-"]');
    if (modal && typeof pipelineVendor !== "undefined" && pipelineVendor.MicroModal) {
      pipelineVendor.MicroModal.show(modal.id, {
        disableScroll: true,
      });
    }
  });
})();
